const bootstrap_modal = require('bootstrap/js/dist/modal');

const conf = {
    id: 'successModal',
    title: 'Благодарим<br> за заявку!',
    body: 'Наш специалист свяжется с Вами в<br> ближайшее время',
    close_timeout: 5000
};

export default function show(to_close = null, title = null, body = null) {

    var modal_box = document.getElementById(conf.id),
        modal = new bootstrap_modal(modal_box)

    modal_box.querySelector('.h2').innerHTML = title ? title : conf.title

    modal_box.querySelector('.description').innerHTML = body ? body : conf.body

    let s_close = false;

    modal_box.addEventListener('shown.bs.modal', function () {
        setTimeout(function () {
            if(!s_close) modal.hide();
        }, conf.close_timeout);
    })

    modal_box.addEventListener('hidden.bs.modal', function () {
        s_close = true;
    });

    if(to_close){
        to_close.addEventListener('hidden.bs.modal', hidden_modal);

        function hidden_modal(){
            modal.show();
            to_close.removeEventListener('hidden.bs.modal', hidden_modal)
        }
        var modal_to_close = bootstrap_modal.getInstance(to_close)
        modal_to_close.hide();
    }else{
        modal.show();
    }
}
